module.exports = __webpack_public_path__ + "b9dcb0db204aa34e5c737ae9b33eb375.svg";